import styled from 'styled-components';

import {
  Flex,
} from 'web-styled';

export const ModalContent = styled(Flex).attrs({
  column: true,
  justify: 'center',
  align: 'center',
  spacing: 8,
})`
  width: 65%;
  min-height: 600px;
  margin: auto;
`;

export const Video = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  padding-top: 9%;
  padding-bottom: 38%;
`;

export const Frame = styled.iframe`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border: none;
`;
